/**
 * @generated SignedSource<<dfd54e9247740605775ae15e963f8bce>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4Profile$data = {
  readonly user: {
    readonly email?: string | null | undefined;
    readonly picture: AGG$URL;
  } | null | undefined;
  readonly " $fragmentType": "Nav4Profile";
};
export type Nav4Profile$key = {
  readonly " $data"?: Nav4Profile$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Profile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "atlassianAccountId"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4Profile",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "accountId",
          "variableName": "atlassianAccountId"
        }
      ],
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "picture"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "email"
            }
          ],
          "type": "AtlassianAccountUser"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "6d28f09535aba53e908aff58b1a38fdd";

export default node;
